import React from "react";
import { about, brand } from "../../mock/mock";

const AboutSection = () => {
  return (
    <section id="about" className="bg-white py-20 md:py-28">
      <div className="max-w-[900px] mx-auto px-5 md:px-8 text-center">
        <img
          src={brand.logo}
          alt="Overdressed Couture"
          className="h-32 md:h-44 w-auto object-contain mx-auto mb-6"
        />
        <p className="font-body text-xs font-semibold tracking-wide-sm uppercase text-[#C8102E] mb-5">
          {about.eyebrow}
        </p>
        <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A] mb-8">
          {about.title}
        </h2>
        {about.paragraphs.map((p) => (
          <p
            key={p.slice(0, 24)}
            className="font-body text-[#555] text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-5"
          >
            {p}
          </p>
        ))}
        <a href="#about" className="inline-block mt-6">
          <span className="inline-block bg-[#822432] text-white font-body text-xs font-semibold uppercase tracking-wide-sm px-9 py-4 rounded-full transition-all duration-300 hover:bg-[#6a1c28]">
            {about.cta}
          </span>
        </a>
      </div>
    </section>
  );
};

export default AboutSection;
